/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface RunReferenceMeasurementRequestInJobOccurrenceDto
 */
export interface RunReferenceMeasurementRequestInJobOccurrenceDto {
    /**
     * 
     * @type {string}
     * @memberof RunReferenceMeasurementRequestInJobOccurrenceDto
     */
    parameterCombinationHash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RunReferenceMeasurementRequestInJobOccurrenceDto
     */
    jobOccurrenceId?: string;
    /**
     * 
     * @type {string}
     * @memberof RunReferenceMeasurementRequestInJobOccurrenceDto
     */
    workItemId?: string;
    /**
     * 
     * @type {string}
     * @memberof RunReferenceMeasurementRequestInJobOccurrenceDto
     */
    $type?: RunReferenceMeasurementRequestInJobOccurrenceDtoTypeEnum;
}


/**
 * @export
 */
export const RunReferenceMeasurementRequestInJobOccurrenceDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoRunReferenceMeasurementRequestInJobOccurrenceDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.RunReferenceMeasurementRequestInJobOccurrenceDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type RunReferenceMeasurementRequestInJobOccurrenceDtoTypeEnum = typeof RunReferenceMeasurementRequestInJobOccurrenceDtoTypeEnum[keyof typeof RunReferenceMeasurementRequestInJobOccurrenceDtoTypeEnum];


/**
 * Check if a given object implements the RunReferenceMeasurementRequestInJobOccurrenceDto interface.
 */
export function instanceOfRunReferenceMeasurementRequestInJobOccurrenceDto(value?: unknown): value is RunReferenceMeasurementRequestInJobOccurrenceDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(RunReferenceMeasurementRequestInJobOccurrenceDtoTypeEnum)[0];
}

export function RunReferenceMeasurementRequestInJobOccurrenceDtoFromJSON(json: any): RunReferenceMeasurementRequestInJobOccurrenceDto {
    return RunReferenceMeasurementRequestInJobOccurrenceDtoFromJSONTyped(json, false);
}

export function RunReferenceMeasurementRequestInJobOccurrenceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunReferenceMeasurementRequestInJobOccurrenceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parameterCombinationHash': !exists(json, 'parameterCombinationHash') ? undefined : json['parameterCombinationHash'],
        'jobOccurrenceId': !exists(json, 'jobOccurrenceId') ? undefined : json['jobOccurrenceId'],
        'workItemId': !exists(json, 'workItemId') ? undefined : json['workItemId'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function RunReferenceMeasurementRequestInJobOccurrenceDtoToJSON(value?: RunReferenceMeasurementRequestInJobOccurrenceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'parameterCombinationHash': value.parameterCombinationHash,
        'jobOccurrenceId': value.jobOccurrenceId,
        'workItemId': value.workItemId,
        '$type': value.$type,
    });
}

